import { get, post, put, del } from './client';

// Themes
export const getThemes = () => get('/admin/themes');
export const getThemeById = (id) => get(`/admin/themes/${id}`);
export const createTheme = (data) => post('/admin/themes', data);
export const updateTheme = (id, data) => put(`/admin/themes/${id}`, data);
export const deleteTheme = (id) => del(`/admin/themes/${id}`);
export const reorderThemes = (themes) => put('/admin/themes/reorder', { themes });

// Products
export const getProducts = () => get('/admin/products');
export const getProductById = (id) => get(`/admin/products/${id}`);
export const createProduct = (formData) => post('/admin/products', formData);
export const updateProduct = (id, formData) => put(`/admin/products/${id}`, formData);
export const updateProductImage = (id, formData) => post(`/admin/products/${id}/image`, formData);
export const toggleProductVisibility = (id) => put(`/admin/products/${id}/visibility`, {});
export const deleteProduct = (id) => del(`/admin/products/${id}`);

// Fragrance Categories
export const getFragranceCategories = () => get('/admin/fragrance-categories');
export const getCategoryById = (id) => get(`/admin/fragrance-categories/${id}`);
export const createCategory = (data) => post('/admin/fragrance-categories', data);
export const updateCategory = (id, data) => put(`/admin/fragrance-categories/${id}`, data);
export const deleteCategory = (id) => del(`/admin/fragrance-categories/${id}`);

// Fragrances
export const getFragrances = () => get('/admin/fragrances');
export const getFragranceById = (id) => get(`/admin/fragrances/${id}`);
export const createFragrance = (data) => post('/admin/fragrances', data);
export const updateFragrance = (id, data) => put(`/admin/fragrances/${id}`, data);
export const toggleFragranceAvailability = (id) => put(`/admin/fragrances/${id}/availability`, {});
export const deleteFragrance = (id) => del(`/admin/fragrances/${id}`);

// Testimonials
export const getTestimonials = () => get('/admin/testimonials');
export const getTestimonialById = (id) => get(`/admin/testimonials/${id}`);
export const createTestimonial = (data) => post('/admin/testimonials', data);
export const updateTestimonial = (id, data) => put(`/admin/testimonials/${id}`, data);
export const toggleTestimonialVisibility = (id) => put(`/admin/testimonials/${id}/visibility`, {});
export const deleteTestimonial = (id) => del(`/admin/testimonials/${id}`);

// Business Settings
export const getBusinessSettings = () => get('/admin/business-settings');
export const updateBusinessSettings = (data) => put('/admin/business-settings', data);

// Users
export const getUsers = () => get('/admin/users');
export const getUserById = (id) => get(`/admin/users/${id}`);
export const createUser = (data) => post('/admin/users', data);
export const updateUser = (id, data) => put(`/admin/users/${id}`, data);
export const toggleUserActive = (id) => put(`/admin/users/${id}/active`, {});
export const deleteUser = (id) => del(`/admin/users/${id}`);
